/**
 * Splits a duration in seconds into whole minutes and remaining seconds
 * (minutes are not wrapped into hours). Returns null when the duration is
 * unknown or not a number.
 *
 * @param {number|null|undefined} totalSeconds
 * @returns {{ minutes: number, seconds: number }|null}
 */
export function splitDuration(totalSeconds) {
  if (totalSeconds === null || totalSeconds === undefined) return null;
  const seconds = Math.max(0, Math.round(Number(totalSeconds)));
  if (!Number.isFinite(seconds)) return null;

  return { minutes: Math.floor(seconds / 60), seconds: seconds % 60 };
}

/**
 * Formats a duration in seconds as m:ss (minutes are not wrapped into hours,
 * so 3754 becomes "62:34"). Returns null when the duration is unknown.
 *
 * @param {number|null|undefined} totalSeconds
 * @returns {string|null}
 */
export default function formatDuration(totalSeconds) {
  const parts = splitDuration(totalSeconds);
  if (!parts) return null;
  return `${parts.minutes}:${String(parts.seconds).padStart(2, '0')}`;
}
